module.exports = __webpack_public_path__ + "img/neighborhoods.ade59e96.jpg";